import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Instagram, Facebook } from "lucide-react";
import { business, nav } from "@/data/site";
import { Logo } from "@/components/Logo";
import { waLink, telLink } from "@/components/ui-kit";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-ink text-ivory grain overflow-hidden">
    <div className="relative z-10 max-w-[1400px] mx-auto px-5 lg:px-10 pt-20 pb-10">
      <div className="grid md:grid-cols-12 gap-12 pb-14 border-b border-white/10">
        <div className="md:col-span-4">
          <Logo light />
          <p className="mt-6 text-ivory/60 text-sm leading-relaxed max-w-xs">
            La palestra a Lusciano pensata intorno a te: sala pesi, corsi fitness, sala olistica,
            personal training e professionisti dedicati al tuo benessere.
          </p>
          <div className="flex gap-3 mt-6">
            <a href="https://www.instagram.com/palestra_body_evolution/?hl=it" target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="social-instagram" className="p-2.5 border border-white/15 rounded-full hover:border-gold hover:text-gold transition-colors"><Instagram size={18} /></a>
            <a href="https://www.facebook.com/palestrabodyevolution" target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="social-facebook" className="p-2.5 border border-white/15 rounded-full hover:border-gold hover:text-gold transition-colors"><Facebook size={18} /></a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="label text-gold mb-5">Menu</div>
          <ul className="space-y-2.5">
            {nav.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-ivory/70 hover:text-gold text-sm transition-colors">{n.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-5">
          <div className="label text-gold mb-5">Contatti</div>
          <ul className="space-y-4 text-sm text-ivory/70">
            <li className="flex gap-3"><MapPin size={18} className="text-gold shrink-0 mt-0.5" /> {business.address}</li>
            <li className="flex gap-3"><Phone size={18} className="text-gold shrink-0 mt-0.5" /><a href={telLink} className="hover:text-gold">{business.phone}</a></li>
            <li className="flex gap-3"><Mail size={18} className="text-gold shrink-0 mt-0.5" /><a href={`mailto:${business.email}`} className="hover:text-gold break-all">{business.email}</a></li>
            <li className="flex gap-3"><Clock size={18} className="text-gold shrink-0 mt-0.5" /> Aperti H24 da settembre · Sabato e domenica aperti</li>
          </ul>
          <div className="mt-6 flex flex-wrap gap-3">
            <a href={waLink()} target="_blank" rel="noreferrer" className="text-xs tracking-wide px-4 py-2.5 rounded-full bg-gold text-ink font-semibold">Scrivici su WhatsApp</a>
            <a href={telLink} className="text-xs tracking-wide px-4 py-2.5 rounded-full border border-white/20 hover:border-gold">Chiama ora</a>
          </div>
        </div>
      </div>

      <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-ivory/40">
        <p>© {new Date().getFullYear()} Body Evolution 2.0 — Palestra a Lusciano (CE). Tutti i diritti riservati.</p>
        <p>Parcheggio · Spogliatoi · Docce · Armadietti</p>
      </div>
    </div>
  </footer>
);
